import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import axios from '../../../utils/axiosInterceptor';
import { DateTime } from 'luxon';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import stringMath from 'string-math';
import { v4 as uuidv4 } from 'uuid';

import {
    Paper, Typography, Button, Container, Fab, Tooltip,
    Dialog, DialogActions, DialogContent, DialogTitle,
    Table, TableHead, TableBody, TableRow, TableCell,
    FormControl, TextField, Box, Divider, Grid, Autocomplete,
    Checkbox, FormGroup, FormControlLabel, Accordion, AccordionSummary, AccordionDetails,
    Card
} from '@mui/material';

import {
    DataGrid, gridClasses,
    gridPageCountSelector,
    GridPagination,
    useGridApiContext,
    GridToolbar,
    useGridSelector,
} from '@mui/x-data-grid';
import MuiPagination from '@mui/material/Pagination';

import CustomMessage from '../../../utils/components/CustomMessage';
import CustomStatusChip from '../../../utils/components/CustomStatusChip';
import CustomChip from '../../../utils/components/CustomChip';
import useWindowDimensions from '../../../utils/functions/useWindowDimensions';
import { formatMoney } from '../../../utils/functions/Utils';
import LocaleTextDataGrid from '../../../utils/functions/LocaleTextDataGrid';
import Config from './Config';

const Cotizador = () => {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [data, setData] = useState([]);
    const [configs, setConfigs] = useState({});
    const [selected, setSelected] = useState('');
    const [key, setKey] = useState('');

    const [maquina, setMaquina] = useState('');
    const [maquinas, setMaquinas] = useState([]);

    const [material, setMaterial] = useState('');
    const [materiales, setMateriales] = useState([]);
    const [currentMaterial, setCurrentMaterial] = useState({ nombre: '', factorMerma: 0 })

    const [open, setOpen] = useState(false);
    const [currentPrice, setCurrentPrice] = useState(null);
    const [disabled, setDisabled] = useState(false);

    const [costosExtras, setCostosExtras] = useState([]);
    const [nombreCE, setNombreCE] = useState('');
    const [cantidadCE, setCantidadCE] = useState(0);
    const [precioUnitarioCE, setPrecioUnitarioCE] = useState(0);
    const [currentCE, setCurrentCE] = useState({ nombre: '', uuid: '', cantidad: 0, precioUnitario: 0, subtotal: 0 });
    const [modalEditCE, setModalEditCE] = useState(false);
    const [modalDeleteCE, setModalDeleteCE] = useState(false);

    const [priceData, setPriceData] = useState({});
    const [showConfig, setShowConfig] = useState(false);

    const [openDelete, setOpenDelete] = useState(false);

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });
    const { height } = useWindowDimensions();

    const estatus = ['confirmado', 'desconocido'];

    useEffect(() => {
        if (!['Admin', 'Vendedor', 'Ayudante'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Cotizador';
    }, [auth])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    const getData = async () => {
        try {
            let res = await axios.get('/api/prices');
            if (res.status === 200) {
                setData(res.data);
            }
            res = await axios.get(`/api/configs/company/${auth.user.company}`);
            if (res.status === 200) {
                setConfigs(res.data);
                setMaquinas(res.data.priceData.maquinas);
                setMateriales(res.data.priceData.materiales);
                setPriceData(res.data.priceData);
            }
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        getData()
    }, [])

    const renderProducts = () => {
        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center' }}>
                    <Button size='small' variant='outlined' onClick={() => navigate('/cotizaciones')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
                    <Typography variant='h5' align='left' sx={{ mt: 1, mb: 1, fontWeight: 700, ml: 3 }}>Cotizador Impresión 3D</Typography>
                </div>
                <Box
                    sx={{
                        [`.${gridClasses.cell}.confirmado`]: {
                            backgroundColor: '#66BB6A88',
                            fontWeight: 500,
                            color: 'text.primary',
                        },
                        [`.${gridClasses.cell}.distribuidor`]: {
                            backgroundColor: '#90CAF988',
                            fontWeight: 500,
                            color: 'text.primary',
                        },
                        [`.${gridClasses.cell}.cliente`]: {
                            backgroundColor: '#A7FFEB88',
                            fontWeight: 500,
                            color: 'text.primary',
                        }
                    }}
                >
                    <DataGrid
                        // autoPageSize={true}
                        sx={{ '& .MuiDataGrid-toolbarContainer': { position: 'fixed', top: '70px', right: '24px' }, '& .MuiButtonBase-root': { color: 'comp.gray' }, '& .MuiDataGrid-row': { backgroundColor: 'comp.tableBg', color: 'text.primary', height: 'auto' }, '& .MuiDataGrid-columnHeader': { backgroundColor: 'comp.tableHeaderBg', color: 'text.primary' } }}
                        style={{ height: `${height - 120}px`, width: '100%' }}
                        localeText={LocaleTextDataGrid}
                        rows={data}
                        density='compact'
                        getRowId={(row) => row._id}
                        onCellClick={(e) => { setSelected(e.row._id) }}
                        onCellDoubleClick={() => handleOpen()}
                        getCellClassName={(params) => {
                            if (params.field !== 'nombre') {
                                return '';
                            }
                            return params.row.estatus;
                        }}
                        columns={[
                            { field: 'date', type: 'date', headerName: 'Fecha', align: 'center', headerAlign: 'center', maxWidth: 200, valueGetter: (params) => DateTime.fromISO(params.row.date).toJSDate() },
                            {
                                field: 'nombre',
                                flex: 1,
                                headerName: 'Nombre',
                                align: 'center',
                                headerAlign: 'center',
                                minWidth: 300,
                                maxWidth: 400,
                            },
                            { field: 'cantidad', flex: 1, minWidth: 60, maxWidth: 70, headerName: '# pza', align: 'center', headerAlign: 'center' },
                            { field: 'material', flex: 1, headerName: 'Material', align: 'center', headerAlign: 'center', maxWidth: 150, valueGetter: (params) => params.row.material?.nombre || '' },
                            // { field: 'maquina', flex: 1, headerName: 'Maquina', align: 'center', headerAlign: 'center', minWidth: 150, valueGetter: (params) => params.row.maquina?.nombre || '' },
                            // { field: 'tiempoDeImpresionMinutos', flex: 1, headerName: 'Tiempo Impresión', align: 'center', headerAlign: 'center', minWidth: 140 },
                            { field: 'design', flex: 1, headerName: 'Diseño', align: 'center', headerAlign: 'center', maxWidth: 70, valueGetter: (params) => params.row.design ? '✔' : '✘' },
                            { field: 'costoTotal', flex: 1, headerName: 'Costo Total', type: 'number', align: 'center', headerAlign: 'center', maxWidth: 120, valueFormatter: (params) => `$ ${formatMoney(params.value)}` },
                            { field: 'ventaDistribuidorSIVA', flex: 1, headerName: 'Dist. S/IVA', type: 'number', align: 'center', headerAlign: 'center', maxWidth: 120, valueFormatter: (params) => `$ ${formatMoney(params.value)}` },
                            { field: 'ventaClienteSIVA', flex: 1, headerName: 'Client. S/IVA', type: 'number', align: 'center', headerAlign: 'center', maxWidth: 120, valueFormatter: (params) => `$ ${formatMoney(params.value)}` },
                            { field: 'precioUnitarioDistribuidor', flex: 1, headerName: 'PU Dist. S/IVA', type: 'number', align: 'center', headerAlign: 'center', maxWidth: 120, cellClassName: 'text-bold distribuidor', valueFormatter: (params) => `$ ${formatMoney(params.value)}` },
                            { field: 'precioUnitarioCliente', flex: 1, headerName: 'PU Client. S/IVA', type: 'text', align: 'center', headerAlign: 'center', maxWidth: 120, cellClassName: 'text-bold cliente', valueFormatter: (params) => `$ ${formatMoney(params.value)}` },
                            { field: 'ganancia', flex: 1, headerName: '% Ganancia', type: 'number', align: 'center', headerAlign: 'center', maxWidth: 120, valueFormatter: (params) => `${formatMoney(params.value)} %` },
                            { field: 'observaciones', flex: 1, headerName: 'Obs', align: 'center', headerAlign: 'center', minWidth: 160 }
                        ]}
                        pagination
                        slots={{
                            pagination: CustomPagination,
                            toolbar: GridToolbar
                        }}
                        initialState={{
                            ...data.initialState,
                            pagination: { paginationModel: { pageSize: 100 } },
                            columns: {
                                columnVisibilityModel: {
                                    vendedor: false,
                                    operacion: false,
                                },
                            }
                        }}
                    />
                </Box>
            </div>
        )
    }

    const updateMaterialesList = (maq) => {
        if (maq !== '') {
            setMaquina(maq);
            setMaterial('');
            const tmpMaquina = maquinas.find(item => item.nombre === maq);
            const tmpMateriales = configs.priceData.materiales.map((item) => {
                if (item.tipo === tmpMaquina.tipoImpresion) {
                    return item;
                }
            });
            setMateriales(tmpMateriales.filter(Boolean));
        }
    }

    const handleOpen = () => {
        setCurrentPrice(data.find(item => item._id === selected));
        setMaquina(data.find(item => item._id === selected)?.maquina?.nombre || '');
        updateMaterialesList(data.find(item => item._id === selected)?.maquina?.nombre || '', data.find(item => item._id === selected));
        setMaterial(data.find(item => item._id === selected)?.material?.nombre || '');
        setCurrentMaterial(data.find(item => item._id === selected)?.material)
        const tmpCE = data.find(item => item._id === selected)?.costosExtras || []

        setCostosExtras(tmpCE.map(item => {
            return {
                nombre: item.nombre,
                cantidad: item.cantidad,
                precioUnitario: item.precioUnitario,
                subtotal: item.subtotal,
                uuid: getUuid()
            };
        }));
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
        setCurrentPrice(null);
    }

    const handleUpdate = async () => {
        setDisabled(true);
        try {
            if (currentPrice._id) {
                const tmp = calculate(currentPrice);
                tmp.material = materiales.find(item => item.nombre === material);
                tmp.maquina = maquinas.find(item => item.nombre === maquina);
                const res = await axios.post(`/api/prices/${tmp._id}`, { price: tmp });
                if (res.status === 200) {
                    setApiRes({ show: true, message: 'Cotización actualizada correctamente', severity: 'success' });
                    setCurrentPrice(null);
                    setOpen(false);
                    getData();
                    setDisabled(false);
                }
            } else {
                const tmp = calculate(currentPrice);
                tmp.material = materiales.find(item => item.nombre === material);
                tmp.maquina = maquinas.find(item => item.nombre === maquina);
                const res = await axios.post(`/api/prices`, { price: tmp });
                if (res.status === 200) {
                    setApiRes({ show: true, message: 'Cotización creada correctamente', severity: 'success' });
                    setCurrentPrice(null);
                    setOpen(false);
                    getData();
                    setDisabled(false);
                }
            }
        } catch (err) {
            console.log(err);
            setApiRes({ show: true, message: 'Error al actualizar la cotización', severity: 'error' });
            setDisabled(false);
        }
    }

    const calculateTime = (tm) => {
        try {
            return stringMath(tm);
        } catch (err) {
            console.log(err);
        }
    }

    const setTempMaterial = (mat) => {
        setMaterial(mat);
        setCurrentMaterial(materiales.find(item => item.nombre === mat) || { nombre: '', factorMerma: 0 });
    }

    const getMaterialString = (cp, cm) => {
        return `${cp.cantidadMaterial} * (1 + ${cm.factorMerma}) = ${formatMoney(cp.cantidadMaterial * (1 + cm.factorMerma))} ${cm.unidad}`
    }

    const renderCotizacionDialog = () => {
        if (currentPrice === null) return;
        return (
            <Dialog
                open={open}
                onClose={() => handleClose()}
                fullWidth
                maxWidth='xxl'
            >
                {
                    currentPrice._id ? <DialogTitle>Editar cotización</DialogTitle> : <DialogTitle>Crear cotización</DialogTitle>
                }
                <DialogContent>
                    <Box sx={{ mb: 2 }}>
                        <Divider sx={{ my: 3 }} textAlign="left">
                            <CustomChip variant='outlined' estatus='ATENDIDO' label='Parámetros de la pieza' className='text-bold' />
                        </Divider>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Pieza'
                                        size='small'
                                        value={currentPrice.nombre}
                                        onChange={(e) => setCurrentPrice({ ...currentPrice, nombre: e.target.value })}
                                        variant='outlined'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={1}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='# Piezas'
                                        size='small'
                                        value={currentPrice.cantidad}
                                        onChange={(e) => setCurrentPrice({ ...currentPrice, cantidad: e.target.value })}
                                        variant='outlined'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={1}>
                                <FormGroup>
                                    <FormControlLabel labelPlacement="left" label='Diseño' control={<Checkbox checked={currentPrice.design} onChange={() => setCurrentPrice({ ...currentPrice, design: !currentPrice.design })} />} />
                                </FormGroup>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                    <Autocomplete
                                        disablePortal
                                        size='small'
                                        freeSolo={false}
                                        onInputChange={(event, newInputValue) => updateMaterialesList(newInputValue)}
                                        inputValue={maquina}
                                        value={maquina}
                                        aria-multiline='true'
                                        options={maquinas.map((option) => option.nombre).concat('')}
                                        renderInput={(params) => <TextField required {...params} label='Maquina' error={maquina === '' ? true : false} helperText={maquina === '' ? 'Debe seleccionar una opción' : ''} />}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                    <Autocomplete
                                        disablePortal
                                        size='small'
                                        // Importante: El valor debe coincidir con el tipo de dato en 'options'
                                        value={material}
                                        onInputChange={(event, newInputValue) => setTempMaterial(newInputValue)}
                                        inputValue={material}

                                        // 1. Mantenemos las opciones como strings simples para que el valor sea el nombre
                                        options={materiales.map((option) => option.nombre)}

                                        // 2. Personalizamos cómo se ve cada item en el menú desplegable
                                        renderOption={(props, option) => {
                                            // Buscamos el objeto original para obtener el costo
                                            const detalleMaterial = materiales.find((m) => m.nombre === option);

                                            return (
                                                <li {...props}>
                                                    {option}
                                                    <span style={{ color: 'gray', marginLeft: '5px' }}>
                                                        {detalleMaterial ? ` ($${formatMoney(detalleMaterial.costo)})` : ''}
                                                    </span>
                                                </li>
                                            );
                                        }}

                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Material'
                                                error={material === ''}
                                                helperText={material === '' ? 'Debe seleccionar una opción' : ''}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tiempo de impresión'
                                        size='small'
                                        value={currentPrice.tiempoDeImpresion}
                                        onChange={(e) => setCurrentPrice({ ...currentPrice, tiempoDeImpresion: e.target.value })}
                                        helperText={currentPrice.tiempoDeImpresionMinutos !== null ? `${currentPrice.tiempoDeImpresionMinutos} minutos` : ''}
                                        variant='outlined'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Material consumido (g, ml)'
                                        size='small'
                                        value={currentPrice.cantidadMaterial}
                                        onChange={(e) => setCurrentPrice({ ...currentPrice, cantidadMaterial: e.target.value })}
                                        variant='outlined'
                                        helperText={getMaterialString(currentPrice, currentMaterial)}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tiempo de post-procesado (minutos)'
                                        size='small'
                                        value={currentPrice.tiempoDePostProcesado}
                                        onChange={(e) => setCurrentPrice({ ...currentPrice, tiempoDePostProcesado: e.target.value })}
                                        variant='outlined'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='% Utilidad'
                                        size='small'
                                        value={currentPrice.utilidad}
                                        onChange={(e) => setCurrentPrice({ ...currentPrice, utilidad: e.target.value })}
                                        variant='outlined'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='% Utilidad Distribuidor'
                                        size='small'
                                        value={currentPrice.utilidadDistribuidor}
                                        onChange={(e) => setCurrentPrice({ ...currentPrice, utilidadDistribuidor: e.target.value })}
                                        variant='outlined'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Descripción'
                                        size='small'
                                        value={currentPrice.descripcion}
                                        onChange={(e) => setCurrentPrice({ ...currentPrice, descripcion: e.target.value })}
                                        variant='outlined'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Observaciones'
                                        size='small'
                                        value={currentPrice.observaciones}
                                        onChange={(e) => setCurrentPrice({ ...currentPrice, observaciones: e.target.value })}
                                        variant='outlined'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                    <Autocomplete
                                        disablePortal
                                        size='small'
                                        freeSolo={true}
                                        onInputChange={(event, newInputValue) => setCurrentPrice({ ...currentPrice, estatus: newInputValue })}
                                        inputValue={currentPrice.estatus}
                                        value={currentPrice.estatus}
                                        defaultValue={'desconocido'}
                                        options={estatus}
                                        renderInput={(params) => <TextField {...params} label='Estatus' />}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <br />
                        <Accordion>
                            <AccordionSummary>
                                <Typography variant='h6' sx={{ fontWeight: '700' }}>Costos extras (por pieza) $ {formatMoney(currentPrice.costoExtraTotal)}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div>
                                    <Grid container spacing={1} className='my-1' sx={{ border: '0.5px solid #ccc', borderRadius: '20px', padding: '10px 4px' }}>
                                        <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <Typography fontWeight={700}>Nombre</Typography>
                                        </Grid>
                                        <Grid item xs={12} md={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <Typography fontWeight={700}>Cantidad</Typography>
                                        </Grid>
                                        <Grid item xs={12} md={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <Typography fontWeight={700}>Precio Unitario</Typography>
                                        </Grid>
                                        <Grid item xs={12} md={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <Typography fontWeight={700}>Subtotal</Typography>
                                        </Grid>
                                        <Grid item xs={12} md={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <Typography fontWeight={700}>Editar</Typography>
                                        </Grid>
                                        <Grid item xs={12} md={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <Typography fontWeight={700}>Eliminar</Typography>
                                        </Grid>
                                    </Grid>
                                    {costosExtras.map((n, i) => (
                                        <Grid container spacing={1} key={i} className='my-1' sx={{ border: '0.5px solid #ddd', borderRadius: '20px', padding: '10px 4px' }}>
                                            <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <Typography fontWeight={700}>{costosExtras[i].nombre}</Typography>
                                            </Grid>
                                            <Grid item xs={12} md={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <Typography sx={{ textAlign: 'center' }}>{costosExtras[i].cantidad}</Typography>
                                            </Grid>
                                            <Grid item xs={12} md={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <Typography>$ {formatMoney(costosExtras[i].precioUnitario)}</Typography>
                                            </Grid>
                                            <Grid item xs={12} md={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <Typography>$ {formatMoney(costosExtras[i].subtotal)}</Typography>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <FormControl style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <Button variant='outlined' color='primary' onClick={() => handleEditCE(costosExtras[i])}>Editar &nbsp;<i className='fad fa-edit'></i></Button>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <FormControl style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <Button variant='outlined' color='error' onClick={() => handleBeforeDeleteCE(costosExtras[i])}>Eliminar &nbsp;<i className='fa fa-trash-alt'></i>&nbsp;</Button>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    ))}
                                </div>
                                <form onSubmit={(e) => handleAddCE(e, { nombre: nombreCE, cantidad: cantidadCE, precioUnitario: precioUnitarioCE })}>
                                    <Grid container spacing={3} className='my-2'>
                                        <Grid item xs={12} md={3}>
                                            <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                                <TextField required label="Nombre" variant="outlined" value={nombreCE} onChange={(e) => setNombreCE(e.target.value)} />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                                <TextField required label="Cantidad" variant="outlined" value={cantidadCE} onChange={(e) => setCantidadCE(e.target.value)} />
                                            </FormControl>
                                        </Grid><Grid item xs={12} md={3}>
                                            <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                                <TextField required label="Precio Unitario" variant="outlined" value={precioUnitarioCE} onChange={(e) => setPrecioUnitarioCE(e.target.value)} />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Button variant='outlined' size='large' color='primary' type='submit'>Agregar costo extra &nbsp; <i className="fad fa-plus-circle"></i></Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </AccordionDetails>
                        </Accordion>
                        <Box sx={{ display: 'flex', justifyContent: 'end', mt: 3 }}>
                            <FormControl >
                                <Button color='primary' variant='contained' size='large' onClick={() => calculate(currentPrice)}>Calcular &nbsp; <i className="fad fa-check"></i></Button>
                            </FormControl>
                        </Box>
                    </Box>
                    <Divider sx={{ my: 5 }} textAlign="center">
                        <CustomChip variant='outlined' estatus='ATENDIDO' label='Cotizacion' className='text-bold' />
                    </Divider>
                    <Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={3}>
                                <Paper sx={{ p: 2 }} elevation={3}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Cantidad</TableCell>
                                                <TableCell>Costo unitario</TableCell>
                                                <TableCell>Costo total</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow >
                                                <TableCell sx={{ fontWeight: '700', fontSize: '1.2em' }}>{currentPrice.cantidad}</TableCell>
                                                <TableCell sx={{ fontWeight: '700', fontSize: '1.2em' }}>$ {formatMoney(currentPrice.costoUnitario)}</TableCell>
                                                <TableCell sx={{ fontWeight: '700', fontSize: '1.2em' }}>$ {formatMoney(currentPrice.costoTotal)}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Paper sx={{ p: 2 }} elevation={3}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align='center' colSpan={3} sx={{ fontWeight: '700', fontSize: '1.1em' }}>Precio Distribuidor</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Venta sin IVA</TableCell>
                                                <TableCell>IVA 16%</TableCell>
                                                <TableCell>Venta con IVA</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow >
                                                <TableCell sx={{ fontWeight: '700', fontSize: '1.2em' }}>$ {formatMoney(currentPrice.ventaDistribuidorSIVA)}</TableCell>
                                                <TableCell sx={{ fontWeight: '700' }}>$ {formatMoney(currentPrice.ivaDistribuidor)}</TableCell>
                                                <TableCell sx={{ fontWeight: '700', fontSize: '1.2em' }}>$ {formatMoney(currentPrice.ventaDistribuidorIVA)}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align='center' colSpan={3} sx={{ fontWeight: '400', fontSize: '1.1em' }}>Unitario</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Venta sin IVA</TableCell>
                                                <TableCell>IVA 16%</TableCell>
                                                <TableCell>Venta con IVA</TableCell>
                                            </TableRow>
                                            <TableRow >
                                                <TableCell sx={{ fontWeight: '700', fontSize: '1.2em' }}>$ {formatMoney(currentPrice.ventaDistribuidorSIVA / currentPrice.cantidad)}</TableCell>
                                                <TableCell sx={{ fontWeight: '700' }}>$ {formatMoney(currentPrice.ivaDistribuidor / currentPrice.cantidad)}</TableCell>
                                                <TableCell sx={{ fontWeight: '700', fontSize: '1.2em' }}>$ {formatMoney(currentPrice.ventaDistribuidorIVA / currentPrice.cantidad)}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <Paper sx={{ p: 2 }} elevation={3}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align='center' colSpan={3} sx={{ fontWeight: '700', fontSize: '1.1em' }}>Precio Cliente</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Venta sugerida sin IVA</TableCell>
                                                <TableCell>IVA 16%</TableCell>
                                                <TableCell>Venta sugerida con IVA</TableCell>
                                                <TableCell>Ganancia</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow >
                                                <TableCell sx={{ fontWeight: '700', fontSize: '1.2em' }}>$ {formatMoney(currentPrice.ventaClienteSIVA)}</TableCell>
                                                <TableCell sx={{ fontWeight: '700' }}>$ {formatMoney(currentPrice.ivaCliente)}</TableCell>
                                                <TableCell sx={{ fontWeight: '700', fontSize: '1.2em' }}>$ {formatMoney(currentPrice.ventaClienteIVA)}</TableCell>
                                                <TableCell sx={{ fontWeight: '700', fontSize: '1.2em' }}>$ {formatMoney(currentPrice.ganancia)} %</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align='center' colSpan={3} sx={{ fontWeight: '400', fontSize: '1.1em' }}>Unitario</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Venta sugerida sin IVA</TableCell>
                                                <TableCell>IVA 16%</TableCell>
                                                <TableCell>Venta sugerida con IVA</TableCell>
                                            </TableRow>
                                            <TableRow >
                                                <TableCell sx={{ fontWeight: '700', fontSize: '1.2em' }}>$ {formatMoney(currentPrice.ventaClienteSIVA / currentPrice.cantidad)}</TableCell>
                                                <TableCell sx={{ fontWeight: '700' }}>$ {formatMoney(currentPrice.ivaCliente / currentPrice.cantidad)}</TableCell>
                                                <TableCell sx={{ fontWeight: '700', fontSize: '1.2em' }}>$ {formatMoney(currentPrice.ventaClienteIVA / currentPrice.cantidad)}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Box>
                    <Divider sx={{ my: 5 }} textAlign="center">
                        <CustomChip variant='outlined' estatus='ATENDIDO' label='Detalle de costos' className='text-bold' />
                    </Divider>
                    <Accordion>
                        <AccordionSummary>
                            <Typography variant='h6' sx={{ fontWeight: '700' }}>Ver detalle de costos</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Box>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Material</TableCell>
                                            <TableCell>Tiempo de impresión</TableCell>
                                            <TableCell>Post procesado</TableCell>
                                            <TableCell>Consumo de energía</TableCell>
                                            <TableCell>Puesta en marcha</TableCell>
                                            <TableCell>Mantenimiento</TableCell>
                                            <TableCell>Empaquetado</TableCell>
                                            <TableCell>Extras</TableCell>
                                            <TableCell>Total</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow >
                                            <TableCell sx={{ fontWeight: '500', fontSize: '1.1em' }}>$ {formatMoney(currentPrice.costoMaterial)}</TableCell>
                                            <TableCell sx={{ fontWeight: '500', fontSize: '1.1em' }}>$ {formatMoney(currentPrice.costoImpresion)}</TableCell>
                                            <TableCell sx={{ fontWeight: '500', fontSize: '1.1em' }}>$ {formatMoney(currentPrice.costoPostProcesado)}</TableCell>
                                            <TableCell sx={{ fontWeight: '500', fontSize: '1.1em' }}>$ {formatMoney(currentPrice.costoConsumoEnergetico)}</TableCell>
                                            <TableCell sx={{ fontWeight: '500', fontSize: '1.1em' }}>$ {formatMoney(currentPrice.costoPuestaEnMarcha)}</TableCell>
                                            <TableCell sx={{ fontWeight: '500', fontSize: '1.1em' }}>$ {formatMoney(currentPrice.costoMantenimiento)}</TableCell>
                                            <TableCell sx={{ fontWeight: '500', fontSize: '1.1em' }}>$ {formatMoney(currentPrice.costoEmbalaje)}</TableCell>
                                            <TableCell sx={{ fontWeight: '500', fontSize: '1.1em' }}>$ {formatMoney(currentPrice.costoExtraTotal)}</TableCell>
                                            <TableCell sx={{ fontWeight: '500', fontSize: '1.1em' }}>$ {formatMoney(currentPrice.costoTotal)}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                </DialogContent>
                <DialogActions>
                    <Button color='success' variant='contained' onClick={() => handleUpdate()} disabled={disabled}>Guardar &nbsp; <i className="fad fa-save"></i></Button>
                    <Button color='warning' variant='contained' onClick={() => handleClose()}>Cerrar &nbsp; <i className="fad fa-times"></i></Button>
                </DialogActions>
            </Dialog>
        )
    }

    const calculate = (params) => {
        const { tiempoDeImpresion, cantidadMaterial, tiempoDePostProcesado, design, cantidad } = params;

        const ti = calculateTime(tiempoDeImpresion);

        const tmpMaterial = configs.priceData.materiales.find(item => item.nombre === material);
        const costoMaterial = cantidadMaterial * tmpMaterial.precioUnitario + cantidadMaterial * tmpMaterial.factorMerma * tmpMaterial.precioUnitario;
        const tmpMaquina = configs.priceData.maquinas.find(x => x.nombre === maquina)
        const costoImpresion = ti * tmpMaquina.depreciacion;
        const costoPostProcesado = tiempoDePostProcesado * configs.priceData.nomina.manoObraMin;

        const costoConsumoEnergetico = (ti * 1.1 * tmpMaquina.consumoKWm) * 2.859;
        const costoPuestaEnMarcha = configs.priceData.puestaEnMarcha.find(item => item.nombre === maquina)?.precioUnitario || 0;
        const costoMantenimiento = configs.priceData.mantenimiento.find(item => item.nombre === maquina)?.precioUnitario || 0;
        const costoEmbalaje = configs.priceData.embalaje.precioUnitario;
        const costoExtraTotal = (costosExtras || []).reduce((acc, curr) => acc + (curr.cantidad * curr.precioUnitario), 0);
        const costoTotal = (costoMaterial + costoImpresion + costoPostProcesado + costoConsumoEnergetico + costoPuestaEnMarcha + costoMantenimiento + costoEmbalaje + costoExtraTotal);

        const costoUnitario = costoTotal / cantidad;
        const ventaDistribuidorSIVA = costoTotal / (1 - (params.utilidadDistribuidor / 100)) + (design ? configs.priceData.costoDesign : 0);
        const ivaDistribuidor = ventaDistribuidorSIVA * 0.16;
        const ventaDistribuidorIVA = ventaDistribuidorSIVA + ivaDistribuidor;
        const ventaClienteSIVA = costoTotal / (1 - (params.utilidad / 100)) + (design ? configs.priceData.costoDesign : 0);
        const ivaCliente = ventaClienteSIVA * 0.16;
        const ventaClienteIVA = ventaClienteSIVA + ivaCliente;
        const ganancia = ((ventaClienteSIVA - costoTotal) / ventaClienteSIVA) * 100;

        const precioUnitarioDistribuidor = ventaDistribuidorSIVA / cantidad;
        const precioUnitarioCliente = ventaClienteSIVA / cantidad;

        const tmpPrice = {
            ...params,
            tiempoDeImpresionMinutos: ti,
            costoMaterial: costoMaterial,
            costoImpresion: costoImpresion,
            costoPostProcesado: costoPostProcesado,
            costoConsumoEnergetico: costoConsumoEnergetico,
            costoPuestaEnMarcha: costoPuestaEnMarcha,
            costoMantenimiento: costoMantenimiento,
            costoEmbalaje: costoEmbalaje,
            costosExtras: costosExtras,
            costoExtraTotal: costoExtraTotal,
            costoTotal: costoTotal,
            costoUnitario: costoUnitario,
            ventaDistribuidorSIVA: ventaDistribuidorSIVA,
            ivaDistribuidor: ivaDistribuidor,
            ventaDistribuidorIVA: ventaDistribuidorIVA,
            ventaClienteSIVA: ventaClienteSIVA,
            ivaCliente: ivaCliente,
            ventaClienteIVA: ventaClienteIVA,
            precioUnitarioDistribuidor: precioUnitarioDistribuidor,
            precioUnitarioCliente: precioUnitarioCliente,
            ganancia: ganancia,
        }

        setCurrentPrice(tmpPrice);
        return tmpPrice;
    }

    const handleNewPrice = () => {
        setCurrentPrice({
            nombre: '',
            descripcion: '',
            cantidad: 1,
            material: '',
            maquina: '',
            tiempoDeImpresion: 0,
            cantidadMaterial: 0,
            tiempoDePostProcesado: 0,
            costosExtras: [],
            tipoImpresion: 'FDM',
            design: false,
            costoTiempoImpresion: 0,
            costoDesign: 0,
            utilidad: 40,
            utilidadDistribuidor: 25,
            postProcesado: { precioUnitario: 0, tiempo: 0, costo: 0 },
            costoConsumoEnergetico: 0,
            costoPuestaEnMarcha: 0,
            costoMantenimiento: 0,
            costoEmbalaje: 0,
            costoTotal: 0,
            costoUnitario: 0,
            ventaDistribuidorSIVA: 0,
            ivaDistribuidor: 0,
            ventaDistribuidorIVA: 0,
            ventaClienteSIVA: 0,
            ivaCliente: 0,
            ventaClienteIVA: 0,
            ganancia: 0,
            observaciones: '',
        });
        setMaquina('');
        setMaterial('');
        setOpen(true);
    }

    const handleOpenDelete = () => {
        setOpenDelete(true);
    }

    const handleCloseDelete = () => {
        setOpenDelete(false);
        setKey('');
        setSelected('');
    }

    const renderDelete = () => {
        return (
            <Dialog
                open={openDelete}
                onClose={handleCloseDelete}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Eliminar cotización</DialogTitle>
                <DialogContent>
                    <Typography variant='body1' align='justify'>
                        ¿Estás seguro que deseas eliminar la cotización seleccionada?
                    </Typography>
                    <Typography variant='body2' align='justify' sx={{ mt: 2 }}>
                        Esta acción no se puede deshacer.
                    </Typography>
                    <FormControl sx={{ mt: 3, minWidth: 100 }} style={{ display: 'flex' }}>
                        <TextField label="Pin" variant="outlined" value={key} onChange={(e) => setKey(e.target.value)} helperText="Ingrese el pin para confirmar" />
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDelete} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleDelete} color="primary" autoFocus>
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleDelete = async () => {
        try {
            const res = await axios.post(`/api/prices/delete`, { price: { _id: selected }, key });
            if (res.status === 200) {
                setApiRes(state => { return { ...state, show: true, message: 'Cotización eliminada correctamente', severity: 'success' } });
                setSelected('');
                setKey('');
                handleCloseDelete();
                getData();
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Pin incorrecto', severity: 'error' } });
        }
    }


    // costos extras

    const getUuid = () => { return uuidv4() };

    const handleAddCE = (e, x) => {
        e.preventDefault();
        x.uuid = getUuid();
        if (x.nombre) {
            setCostosExtras(costosExtras => [...costosExtras, {
                nombre: x.nombre,
                cantidad: x.cantidad,
                precioUnitario: x.precioUnitario,
                subtotal: Number(x.cantidad) * Number(x.precioUnitario),
                uuid: x.uuid
            }]);
        }
        else {
            setCostosExtras(costosExtras => [...costosExtras, {
                cantidad: x.cantidad,
                precioUnitario: x.precioUnitario,
                subtotal: Number(x.cantidad) * Number(x.precioUnitario),
                uuid: x.uuid
            }]);
        }
        setNombreCE('');
        setPrecioUnitarioCE('');
        setCantidadCE('');
    }

    const handleUpdateCE = (d, e) => {
        setModalEditCE(false);
        let tmp = {}
        tmp.uuid = e;
        if (d.nombre)
            if (d.nombre !== '')
                tmp.nombre = d.nombre;
        if (d.precioUnitario)
            tmp.precioUnitario = d.precioUnitario;
        if (d.cantidad)
            tmp.cantidad = d.cantidad;
        tmp.subtotal = Number(tmp.cantidad) * Number(tmp.precioUnitario);
        setCostosExtras(costosExtras.map(r => r.uuid === e ? tmp : r));
    }

    const handleCloseEditCE = () => {
        setModalEditCE(false);
        setCurrentCE({ nombre: '', uuid: '', cantidad: 0, precioUnitario: 0, subtotal: 0 });
    }

    const handleCloseDeleteCE = () => {
        setModalDeleteCE(false);
        setCurrentCE({ nombre: '', uuid: '', cantidad: 0, precioUnitario: 0, subtotal: 0 });
    }

    const handleEditCE = (d) => {
        setCurrentCE(d);
        setModalEditCE(true);
    }

    const renderEditCE = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={modalEditCE}
                scroll='paper'
                onClose={handleCloseEditCE}>
                <DialogTitle >Editar Costo Extra</DialogTitle>
                <DialogContent>
                    {currentCE ?
                        <div>
                            <Grid container spacing={1}>
                                <Grid item sm={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Nombre" variant="outlined" value={currentCE.nombre} onChange={(e) => setCurrentCE({ ...currentCE, nombre: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Cantidad" variant="outlined" value={currentCE.cantidad} onChange={(e) => setCurrentCE({ ...currentCE, cantidad: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Precio Unitario" variant="outlined" value={currentCE.precioUnitario} onChange={(e) => setCurrentCE({ ...currentCE, precioUnitario: e.target.value })} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </div> : <div></div>}
                    <br />
                    <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
                        <Button variant='contained' color='primary' className='m-1 p-2' onClick={() => handleUpdateCE(currentCE, currentCE.uuid)}>&nbsp;Actualizar &nbsp;&nbsp;<i className='fad fa-cogs' style={{ transform: 'scale(1.3)' }}></i>&nbsp;</Button>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseEditCE()}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleBeforeDeleteCE = (d) => {
        setCurrentCE(d);
        setModalDeleteCE(true);
    }

    const handleDeleteCE = (d, r) => {
        if (r < 2) {
            setCostosExtras([]);
        } else {
            setCostosExtras(costosExtras.filter(x => x.uuid !== d)); // filter pie array to remove the one with the key
        }
        handleCloseDeleteCE();
    }

    const renderDeleteCE = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'sm'}
                open={modalDeleteCE}
                scroll='paper'
                onClose={handleCloseDeleteCE}>
                <DialogTitle >Eliminar Costo Extra</DialogTitle>
                <DialogContent>
                    <Typography variant='body1' sx={{ mb: 2 }}>¿Está seguro de eliminar el costo extra?</Typography>
                    <Typography variant='body1'>Nombre: <span style={{ fontWeight: 700 }}> {currentCE.nombre}</span></Typography>
                    <Typography variant='body1'>cantidad: <span style={{ fontWeight: 700 }}>{currentCE.cantidad}</span></Typography>
                    <Typography variant='body1'>Precio Unitario: <span style={{ fontWeight: 700 }}>{currentCE.precioUnitario}</span></Typography>
                    <Button variant='contained' color='error' onClick={() => handleDeleteCE(currentCE.uuid, costosExtras.length)} style={{ marginTop: '24px' }}>Eliminar &nbsp; <i className="fad fa-delete"></i></Button>
                </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseDeleteCE()}>Cerrar &nbsp; <i className="fad fa-times"></i></Button>
                </DialogActions>
            </Dialog>
        )
    }

    // config

    const renderConfig = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={showConfig}
                scroll='paper'
                onClose={handleCloseConfig}>
                <DialogTitle>Configuración</DialogTitle>
                <DialogContent>
                    <Config />
                </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseConfig()}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleCloseConfig = () => {
        setShowConfig(false)
    }

    return (
        <Container maxWidth='xxl' sx={{ width: '100%', overflow: 'hidden', margin: '0px', padding: '4px 4px !important' }}>
            <Paper>
                <Tooltip title='Nueva cotización' placement='top' arrow>
                    <Fab onClick={handleNewPrice} aria-label="add" color='success' style={{ position: 'fixed', bottom: '8px', left: '8px', zIndex: '10', color: '#FFF' }}>
                        <i className="fad fa-plus fa-2x"></i>
                    </Fab>
                </Tooltip>
                <Tooltip onClick={() => setShowConfig(true)} title='Configuración' placement='top' arrow>
                    <Fab aria-label="add" color='primary' style={{ position: 'fixed', bottom: '8px', left: '98px', zIndex: '10', color: '#FFF' }}>
                        <i className="fad fa-cog fa-2x"></i>
                    </Fab>
                </Tooltip>
                {selected !== '' ?
                    <div>
                        <Tooltip title='Eliminar cotización' placement='top' arrow>
                            <Fab aria-label="add" color='error' style={{ position: 'fixed', bottom: '8px', left: '165px', zIndex: '10', color: '#FFF' }} onClick={handleOpenDelete}>
                                <i className="fad fa-trash fa-2x"></i>
                            </Fab>
                        </Tooltip>
                    </div>
                    : null}
                {renderProducts()}
                {renderCotizacionDialog()}
                {renderEditCE()}
                {renderDeleteCE()}
                {renderConfig()}
                {renderDelete()}
                <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
            </Paper>
        </Container>
    );
}

function Pagination({ page, onPageChange, className }) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
        <MuiPagination
            color="primary"
            className={className}
            count={pageCount}
            page={page + 1}
            onChange={(event, newPage) => {
                onPageChange(event, newPage - 1);
            }}
        />
    );
}

function CustomPagination(props) {
    return <GridPagination ActionsComponent={Pagination} {...props} />;
}

export default Cotizador;